<script lang="typescript">
  import RenderedMap from './Map.svelte';
  import { getColor, NEUTRAL, TIE } from '../colors';
  import { formatPercent } from '../utils/format-percent';

  // types
  import type { Feature, FeatureCollection } from 'geojson';
  import type { Readable } from 'svelte/store';
  import type {
    CandidateInterface,
    CandidateLookup,
    SubunitLookup,
    TooltipCandidateInterface,
  } from '../interfaces';

  export let geography: FeatureCollection;
  export let roads: FeatureCollection;
  export let cities: FeatureCollection;
  export let candidates: Readable<CandidateLookup>;
  export let subunits: Readable<SubunitLookup>;

  $: getFillStyle = (feature: Feature) => {
    const code: string = feature.properties!.code;
    const subunit = $subunits.get(code);

    let color: string;

    if (!subunit) {
      color = NEUTRAL;
    } else if (subunit.total_votes <= 0) {
      color = NEUTRAL;
    } else {
      const [leaderApId, leaderVotes] = subunit.results[0];
      const [, secondVotes] = subunit.results[1];

      if (leaderVotes === secondVotes) {
        color = TIE;
      } else {
        const candidate = $candidates.get(leaderApId) as CandidateInterface;
        const partyColor = getColor(candidate.party);

        color = partyColor;
      }
    }

    return color;
  };

  $: findRaceData = (feature?: Feature) => {
    if (feature) {
      const subunit = $subunits.get(feature.properties.code);

      if (subunit) {
        const results = subunit.results;

        const cands = results
          .filter(([_, votes]) => votes > 0)
          .slice(0, 3)
          .map(([ap_id, votes]) => {
            const candidate = $candidates.get(ap_id) as CandidateInterface;
            return {
              ap_id,
              name: candidate.family_name,
              party: candidate.party,
              votes,
              votePercent: formatPercent(votes, subunit.total_votes),
            } as TooltipCandidateInterface;
          });

        return {
          name: subunit.name,
          candidates: cands,
          totalVotes: subunit.total_votes,
          precinctsTotal: subunit.precincts_total,
          precinctsReporting: subunit.precincts_reporting,
        };
      }
    } else {
      return undefined;
    }
  };
</script>

<RenderedMap {getFillStyle} {findRaceData} {geography} {roads} {cities} />
